import React from "react"
import { Grid } from "@mui/material"
import { postExcel } from "@ui-seeker/utils"

import { AppBasicTable, AppNote, AppResultsSkeleton } from "@components"
import { BACKEND_APIS } from "@constants"
import { isOneWayLoading, oneWayData, oneWayExcelPayload } from "Pages/AnalyzersV2/OneWay/@signals"
import { axisColumn, feesColumn } from "./columns"
import { axisHeader, datesHeader } from "./headers"
import { isOneWaySiteAxis, oneWayAxisLabel } from "./axis"
import OneWayTableTitle from "./Title"


export default function OneWayTable() {

	const { results, headers, subHeaders, subColumns } = oneWayData.value || {}

	if (isOneWayLoading.value) return <Grid item xs={12}><AppResultsSkeleton rows={7} columns={8}/></Grid>
	if (!headers) return null

	if (!results?.length) return <Grid item xs={12}>
		<AppNote>
			No one way rows for this execution. This analyzer needs an execution whose searches drop
			off at a different office than the pickup one, which is what One Way reports produce.
		</AppNote>
	</Grid>

	const lors = subHeaders || []
	const acrissCodes = subColumns || []

	return <Grid item xs={12}>
		<AppBasicTable
			onDownload={() => postExcel(`${BACKEND_APIS.DASHBOARD}/excel`, oneWayExcelPayload.value)}
			toolbarProps={{ actions: false }}
			titleProps={{ actions: false }}
			data={results}
			headers={[[axisHeader(oneWayAxisLabel()), ...headers.map(header => datesHeader(header, lors, acrissCodes))]]}
			columns={[
				axisColumn(isOneWaySiteAxis()),
				...headers.map(date => feesColumn(date, lors, acrissCodes)),
			]}
			Components={{
				Title: () => <OneWayTableTitle />
			}}
		/>
	</Grid>
}
